import React, { useState, useEffect, Fragment } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { login, clearAuthError } from '../../store/actions/authActions';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/gattomioNero.png';
import paws8 from '../../images/paws-8.png';
import paws10 from '../../images/paws-10.png';
import './AuthPage.scss';

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { isAuthenticated, loading, error } = useSelector(state => state.auth);

  const [formData, setFormData] = useState({ email: '', password: '' });
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    if (isAuthenticated) {
      const from = location.state?.from || '/';
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, location]);

  useEffect(() => {
    dispatch(clearAuthError());
  }, [dispatch]);

  const validate = () => {
    const errors = {};
    if (!formData.email) errors.email = 'Email obbligatoria';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) errors.email = 'Email non valida';
    if (!formData.password) errors.password = 'Password obbligatoria';
    else if (formData.password.length < 8) errors.password = 'Minimo 8 caratteri';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (formErrors[e.target.name]) {
      setFormErrors({ ...formErrors, [e.target.name]: '' });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      await dispatch(login(formData.email, formData.password));
    } catch (err) {
      // Errore gestito dal reducer
    }
  };

  return (
    <Fragment>
      <Navbar hclass={'wpo-site-header'} Logo={Logo} />
      <PageTitle pageTitle={'Accedi'} pagesub={'Login'} />

      <section className="wpo-auth-section section-padding">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">

              <div className="auth-wrapper">
                {/* Left decorative panel */}
                <div className="auth-side-panel">
                  <div className="side-panel-content">
                    <div className="side-panel-icon">
                      <img src={paws8} alt="Petlox paw" />
                    </div>
                    <h3>Bentornato nella famiglia Petlox!</h3>
                    <p>
                      Accedi per gestire i tuoi ordini
                      e scoprire le ultime novità per il tuo amico a 4 zampe.
                    </p>
                    <Link to="/register" className="side-panel-btn">
                      Crea un account
                    </Link>
                  </div>
                </div>

                {/* Right form panel */}
                <div className="auth-form-panel">
                  <div className="auth-form-header">
                    <span className="auth-subtitle">Area Riservata</span>
                    <h2>Accedi</h2>
                    <p>Inserisci le tue credenziali per continuare</p>
                  </div>

                  {error && (
                    <div className="auth-alert">
                      <span className="alert-icon">
                        <i className="ti-alert"></i>
                      </span>
                      <p>{error}</p>
                    </div>
                  )}

                  <form className="auth-form" onSubmit={handleSubmit} noValidate>
                    <div className="form-group">
                      <label>Email</label>
                      <div className="input-wrapper">
                        <input
                          type="email"
                          name="email"
                          className={formErrors.email ? 'is-invalid' : ''}
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="la-tua@email.com"
                          autoComplete="email"
                        />
                        <i className="ti-email field-icon"></i>
                      </div>
                      {formErrors.email && <div className="invalid-feedback">{formErrors.email}</div>}
                    </div>

                    <div className="form-group">
                      <label>Password</label>
                      <div className="input-wrapper">
                        <input
                          type="password"
                          name="password"
                          className={formErrors.password ? 'is-invalid' : ''}
                          value={formData.password}
                          onChange={handleChange}
                          placeholder="La tua password"
                          autoComplete="current-password"
                        />
                        <i className="ti-lock field-icon"></i>
                      </div>
                      {formErrors.password && <div className="invalid-feedback">{formErrors.password}</div>}
                    </div>

                    <div className="submit-area">
                      <button
                        type="submit"
                        className="theme-btn"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Accesso in corso...
                          </>
                        ) : 'Accedi'}
                      </button>
                    </div>
                  </form>

                  <div className="auth-switch-link" style={{ marginTop: '16px', marginBottom: '4px' }}>
                    <p>
                      <Link to="/forgot-password">Hai dimenticato la password?</Link>
                    </p>
                  </div>

                  <div className="auth-divider">
                    <span>oppure</span>
                  </div>

                  <div className="auth-switch-link">
                    <p>
                      Non hai un account?{' '}
                      <Link to="/register">Registrati ora</Link>
                    </p>
                  </div>
                </div>
              </div>

              {/* Decorative paw images */}
              <img src={paws8} alt="" className="paw-decoration paw-top-right" />
              <img src={paws10} alt="" className="paw-decoration paw-bottom-left" />

            </div>
          </div>
        </div>
      </section>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default LoginPage;
